module.exports = __webpack_public_path__ + "static/media/icon-character__francisco-franco-hover.15e80758.svg";